import React from 'react';
import { Input } from 'antd';
import history from '$lib/history';
import { reverse } from 'named-urls';
import routes from '@achievable-me/tundra-wizard/routes';
import DashboardHeader from '$components/ProductDashboard/DashboardHeader';
import DashboardSubheader from '$components/ProductDashboard/DashboardSubheader';
import getPlaceholder from '$components/student/Search/getPlaceholder';

const handleSearch = (product) => (query) => {
  const { slug: productSlug } = product;
  const route = `${reverse(routes.study.search, {
    productSlug,
  })}?query=${encodeURIComponent(query)}`;
  history.push(route);
};

const MiniSearch = (props) => {
  const { product } = props;
  const onSearch = handleSearch(product);
  const placeholder = getPlaceholder(product);
  return (
    <div>
      <DashboardHeader header="Search textbook" />
      <DashboardSubheader>
        Look up which topics contain a word or phrase
      </DashboardSubheader>
      <Input.Search
        data-aaa="search"
        placeholder={placeholder}
        onSearch={onSearch}
        enterButton
      />
    </div>
  );
};

export default MiniSearch;
